<!-- Layout principal com formulário centralizado -->
<div class="request-password-container" #requestPasswordContainer>
  <!-- Formulário de reset de senha centralizado -->
  <div class="request-password-section">
    <div class="request-password-form">
      <div class="system-title">
        <h1 class="title">Reset de Senha</h1>
        <h2 class="system-name">Reno Inteligência</h2>
      </div>
      <p class="sub-title">Esqueceu sua senha? Não se preocupe!</p>
      <p class="description">Digite seu e-mail e enviaremos instruções para redefinir sua senha.</p>

      <nb-alert *ngIf="showMessages.error && errors?.length && !submitted" outline="danger" role="alert">
        <p class="alert-title"><b>Erro</b></p>
        <ul class="alert-message-list">
          <li *ngFor="let error of errors" class="alert-message">{{ error }}</li>
        </ul>
      </nb-alert>

      <nb-alert *ngIf="showMessages.success && messages?.length && !submitted" outline="success" role="alert">
        <p class="alert-title"><b>Sucesso!</b></p>
        <ul class="alert-message-list">
          <li *ngFor="let message of messages" class="alert-message">{{ message }}</li>
        </ul>
        <p class="redirect-message">Redirecionando para o login em alguns segundos...</p>
      </nb-alert>

      <!-- Formulário de reset de senha -->
      <form *ngIf="!showMessages.success" (ngSubmit)="requestPassword()" #form="ngForm" aria-labelledby="title">
        <div class="form-control-group">
          <label class="label" for="input-email">Endereço de E&ndash;mail:</label>
          <input nbInput
                 fullWidth
                 [(ngModel)]="user.email"
                 #email="ngModel"
                 name="email"
                 id="input-email"
                 type="email"
                 pattern=".+@.+\..+"
                 placeholder="Digite seu e-mail"
                 fieldSize="large"
                 autofocus
                 [required]="getConfigValue('forms.validation.email.required')"
                 [attr.aria-invalid]="email.invalid && email.touched ? true : null"
                 tabindex="1">
          <ng-container *ngIf="email.invalid && email.touched">
            <p class="caption status-danger" *ngIf="email.errors?.required">
              Preencha seu E&ndash;mail!
            </p>
            <p class="caption status-danger" *ngIf="email.errors?.pattern">
              O e-mail deve ser válido!
            </p>
          </ng-container>
        </div>

        <button nbButton
                fullWidth
                status="primary"
                size="large"
                [disabled]="submitted || !form.valid"
                [class.btn-pulse]="submitted"
                tabindex="2"
                class="request-password-btn">
          {{ submitted ? 'Enviando...' : 'Enviar Instruções' }}
        </button>
      </form>

      <!-- Botão para voltar ao login -->
      <div class="back-to-login-section">
        <button nbButton
                ghost
                status="basic"
                size="medium"
                (click)="goBackToLogin()"
                class="back-to-login-btn">
          <nb-icon icon="arrow-back-outline" pack="eva"></nb-icon>
          Voltar ao Login
        </button>
      </div>

      <!-- Informações adicionais -->
      <div class="additional-info">
        <p class="info-text">
          <nb-icon icon="info-outline" status="info"></nb-icon>
          <span>As instruções serão enviadas para o e-mail cadastrado em sua conta.</span>
        </p>
        <p class="info-text">
          <nb-icon icon="clock-outline" status="warning"></nb-icon>
          <span>O link de reset expira em 24 horas por questões de segurança.</span>
        </p>
      </div>
    </div>
  </div>
</div>
